import { IconButton } from 'components/shared/IconButton';
import { ConfirmModal, ConfirmModalProps } from 'components/shared/Modals/ConfirmModal';
import { useAssertedActiveTabId } from 'hooks/use-asserted-active-tab-id';
import { useThunkDispatch } from 'hooks/useThunkDispatch';
import { useToggle } from 'hooks/useToggle';
import { FormattedMessage, useIntl } from 'react-intl';
import { DisclaimerTrigger } from 'routes/smart-quote/components/disclaimer';
import { useHasActiveTabSmartQuotePrompts } from 'routes/smart-quote/hooks/use-sort-prompts';
import { trackSmartQuoteEvent } from 'routes/smart-quote/utils';
import { resetTabRequestedThunk } from 'state/workspaces/smart-quote/thunks';

export function HeaderActions() {
  const dispatch = useThunkDispatch();
  const { formatMessage } = useIntl();
  const { isOn: isModalOpened, toggleOff: closeModal, toggleOn: openModal } = useToggle();

  const tabId = useAssertedActiveTabId();
  const hasPrompts = useHasActiveTabSmartQuotePrompts();

  const handleResetTab = () => {
    closeModal();
    dispatch(resetTabRequestedThunk(tabId));
    trackSmartQuoteEvent('reset tab', 'confirm');
  };

  const handleOpen = () => {
    openModal();
    trackSmartQuoteEvent('reset tab', 'open confirm');
  };

  const handleCancel: ConfirmModalProps['onClosed'] = reason => {
    closeModal();
    trackSmartQuoteEvent('reset tab', `close - ${reason}`);
  };

  const trackDisclaimer = () => {
    trackSmartQuoteEvent('disclaimer', 'open - header info button');
  };

  return (
    <div className="flex-x p-2">
      <IconButton
        iconName="settings_backup_restore"
        className="btn-lg"
        ariaLabel={formatMessage({ id: 'smartQuote.workspace.refresh.btn.ariaLabel' })}
        onClick={handleOpen}
        isDisabled={!hasPrompts}
      />
      <ConfirmModal
        titleKey="smartQuote.workspace.reset.title"
        confirmBtnKey="reset"
        confirmBtnIcon="settings_backup_restore"
        header={{ className: 'p-0' }}
        bodyClassName="px-4 pb-0 pt-0"
        titleClassName="h4 lh-1 p-4 me-auto"
        confirmBtnClassName="btn btn-lg btn-discreet-danger"
        cancelBtnClassName="btn btn-lg btn-flat-secondary"
        dialogClassName=""
        show={isModalOpened}
        onClosed={handleCancel}
        onConfirm={handleResetTab}
        withCloseButton
      >
        <FormattedMessage id="smartQuote.workspace.reset.confirmationMessage" />
      </ConfirmModal>

      <DisclaimerTrigger>
        <button
          onClick={trackDisclaimer}
          className="btn btn-flat-secondary btn-lg btn-icon"
          aria-label={formatMessage({ id: 'smartQuote.workspace.info.btn.ariaLabel' })}
        >
          <i className="icon icon-outlined" aria-hidden="true">
            info
          </i>
        </button>
      </DisclaimerTrigger>
    </div>
  );
}
